export function urlParamsToObject (params) {
  let entries = new URLSearchParams(params).entries() // returns an iterator of decoded [key,value] tuples
  let result = {}
  for (let entry of entries) { // each 'entry' is a [key, value] tupple
    result[entry[0]] = entry[1]
  }
  return result
}
export function objectToUrlParams (param, key, encode) {
  if (param == null) return ''
  var paramStr = ''
  var t = typeof (param)
  if (t === 'string' || t === 'number' || t === 'boolean') {
    paramStr += '&' + key + '=' + ((encode == null || encode) ? encodeURIComponent(param) : param)
  } else {
    for (var i in param) {
      var k = key == null ? i : key + (param instanceof Array ? '[' + i + ']' : '.' + i)
      paramStr += objectToUrlParams(param[i], k, encode)
    }
  }
  return paramStr
}

export function createGUID () {
  var s = []
  var hexDigits = '0123456789abcdef'
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
  }
  s[14] = '4' // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = '-'
  return s.join('')
}

export function GUID2(){
    //获取一个上传视频线程的guid
    return "xxxxxxxx-xxxx-xxxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function(c) {
            var r = (Math.random() * 16) | 0,
                v = c == "x" ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        }
    );
}

// 设置cookie
export function setCookie (cname, cvalue, exdays) {
  var d = new Date()
  d.setTime(d.getTime() + ((exdays || 1) * 24 * 60 * 60 * 1000))
  var expires = 'expires=' + d.toUTCString()
  document.cookie = cname + '=' + cvalue + '; ' + expires
  console.log(document.cookie)
}
// 获取cookie
export function getCookie (cname) {
  var name = cname + '='
  var ca = document.cookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) === ' ') c = c.substring(1)
    if (c.indexOf(name) !== -1) return c.substring(name.length, c.length)
  }
  return ''
}
// 清除cookie
export function clearCookie (name) {
  if (name) {
    setCookie(name, '', -1)
  } else {
    var cookies = getCookie()
    console.log(cookies)
  }
}

// 设置cookie（直接指定过期时间）
export function setCookieExpiresTime (cname, cvalue, expiresTime) {
  var expires = 'expires=' + expiresTime.toUTCString()
  document.cookie = cname + '=' + cvalue + '; ' + expires
  console.log(document.cookie)
}

// 防抖
export function _debounce (fn, time) {
  let delay = time || 500
  let timer
  return function () {
    let that = this
    let args = arguments
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(function () {
      timer = null
      fn.apply(that, args)
    }, delay)
  }
}

// 获取url参数
export function getQueryVariable (variable) {
  var query = window.location.search.substring(1)
  var vars = query.split('&')
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=')
    if (pair[0] == variable) { return pair[1] }
  }
  return (false)
}

export function timeQuantum(lastTime,nextTime){
  var timeDifference = nextTime|| new Date() - lastTime;//时间差的毫秒数
  if(timeDifference<0){
    return -1;
  }
  return Math.ceil(timeDifference/1000);
}
